// import React, { useEffect, useRef, useState } from "react";
// import PlusIcon from "../../../src/assets/images/plusIconSquare.svg";
// import deleteIcon from "../../../src/assets/images/deleteItinerary.png"
// import CkEditor from "../../common/ckEditor/ckeditor";
// import JoditEditor from "jodit-react";






// const ItinraryBoxField = ({currentPackage,setState}) => {
//   const [fieldData, setFieldData] = useState([
//     { title: "", description: "" },
//   ]);
//   console.log(fieldData,"fieldData");
//   const prevItineraryRef = useRef("");

//   const handleaddfield=()=>{
//     setFieldData([...fieldData,{
//       title:"",
//       description:""}])
//   }
//   const handleFieldChange = (index, key, value) => {
    
//     const updatedFields = fieldData.map((item, i) =>
//       i === index ? { ...item, [key]: value } : item
//     );
//     setFieldData(updatedFields);
//   };

//   const handledelete=(index)=>{
//     const deleteandupdate=fieldData.filter((elem,indx)=>{
//         return index!==indx
//     })
//     setFieldData(deleteandupdate)


//   }
  
//   // useEffect(() => {
//   //   const formattedItinerary = fieldData?.reduce((acc, elem, indx) => {
//   //     acc[`day_${indx + 1}`] = {
//   //       title: elem.title,
//   //       content: [
//   //         {
//   //           description: elem.description,
//   //         },
//   //       ],
//   //     };
//   //     return acc;
//   //   }, {});
  
//   //   setState((prevState) => ({
//   //     ...prevState,
//   //     itinerary: JSON.stringify(formattedItinerary), // Store as plain object
//   //   }));
//   // }, [fieldData]);
//   useEffect(() => {
//     const formattedItinerary = fieldData?.reduce((acc, elem, indx) => {
//       acc[`day_${indx + 1}`] = {
//         title: elem.title,
//         content: [
//           {
//             description: elem.description,
//           },
//         ],
//       };
//       return acc;
//     }, {});

//     const formattedJSON = JSON.stringify(formattedItinerary);

//     if (prevItineraryRef.current !== formattedJSON) {
//       prevItineraryRef.current = formattedJSON;
//       setState((prevState) => ({
//         ...prevState,
//         itinerary: formattedJSON,
//       }));
//     }
//   }, [fieldData]);

//   // useEffect(()=>{
//   //   console.log(currentPackage?.itinerary,"itinerary");
//   //   if(currentPackage?.itinerary && typeof currentPackage?.itinerary==="string"){
//   //     const result = Object.entries(JSON.parse(currentPackage?.itinerary)).map(([key, value]) => ({
//   //       title: value.title,
//   //       description: value.content[0].description
//   //     }));
//   //     setFieldData(result)
     
      

//   //   }
//   // },[currentPackage?.itinerary])
//   useEffect(() => {
//     if (
//       currentPackage?.itinerary &&
//       typeof currentPackage?.itinerary === "string"
//     ) {
//       const result = Object.entries(
//         JSON.parse(currentPackage.itinerary)
//       ).map(([key, value]) => ({
//         title: value.title,
//         description: value.content[0].description,
//       }));

//       setFieldData(result);
//     }
//   }, [currentPackage?.itinerary]);

//     return (
//         <div style={{ padding: "12px" }}>
            
//             <p style={{fontWeight:"600"}}>Itinerary days</p>
            

//             {fieldData?.map((elem,indx)=>{
//               return(
//                 <>
//              <div
//                 style={{
//                     backgroundColor: "white",
//                     height: "auto",
//                     margin: "25px 0px",
//                     borderRadius: "12px",
//                     padding: "10px",
//                 }}
//             >
//                    <div style={{display:"flex",justifyContent:"space-between"}}>
//             <p style={{marginLeft:"0"}}> Day {indx+1}</p>
//             <img
//                     src={deleteIcon}
//                     alt="addIcon"
//                     style={{height:"30px",width:"30px"}}
//                     onClick={()=>handledelete(indx)}
                   
//                 />
//             </div>
//             <p style={{marginBottom:"2px"}}>Title</p>
//                 <input
//                     type="text"
                    
//                     style={{
//                         width: "100%",
//                         height: "35px",
//                         backgroundColor: "#F4F4F4",
//                         borderRadius: "6px",
//                         padding: "9px",
//                         border: "none",
//                         marginBottom:"10px"
//                     }}
//                     value={elem.title}
//                     onChange={(e) => handleFieldChange(indx, "title", e.target.value)}
//                 ></input>
              
//                 {/* <textarea
//                     type="text"
//                     placeholder="Description"
//                     style={{
//                         width: "100%",
//                         height: "100px",
//                         backgroundColor: "#F4F4F4",
//                         borderRadius: "6px",
//                         padding: "9px",
//                         border: "none",
//                         margin: "15px 0px 0px 0px",
//                         resize: "none",
//                     }}
//                     value={elem.description}
//                     onChange={(e) => handleFieldChange(indx, "description", e.target.value)}
//                 ></textarea> */}
//                 <p style={{marginBottom:"2px"}}>Description</p>
//               <CkEditor
//                       data={elem.description}
//                       handleChange={(newContent) => { handleFieldChange(indx, "description", newContent)}}
                 
                     
                    
//                />
               
//             </div>
//                 </>
//               )
      
//             })}

// <div
//                 onClick={handleaddfield}
//                 style={{
//                     position: "relative",
//                     marginTop: "0px",
//                     marginBottom: "0px",
//                     backgroundColor: "white",
//                     width: "110px",
//                     height: "38px",
//                     border: "1px solid black",
//                     padding: "8px",
//                     cursor: "pointer",
//                     fontSize: "15px",
//                 }}
//             >
//                 Add Days
//                 <img
//                     src={PlusIcon}
//                     alt="addIcon"
//                     style={{
//                         position: "absolute",
//                         left: "80%",
//                         top: "12px",
//                         height: "12px",
//                     }}
//                 />
//             </div>
//         </div>
//     );
// };

// export default ItinraryBoxField;



import React, { useEffect, useState, useRef } from "react";
import PlusIcon from "../../../src/assets/images/plusIconSquare.svg";
import deleteIcon from "../../../src/assets/images/deleteItinerary.png";
import CkEditor from "../../common/ckEditor/ckeditor";

const ItinraryBoxField = ({ currentPackage, setState }) => {
  const [fieldData, setFieldData] = useState([{ title: "", description: "" }]);
  const prevItineraryRef = useRef("");
  const didInit = useRef(false);

  const handleAddField = () => {
    setFieldData([...fieldData, { title: "", description: "" }]);
  };

  const handleFieldChange = (index, key, value) => {
    const updatedFields = fieldData.map((item, i) =>
      i === index ? { ...item, [key]: value } : item
    );
    setFieldData(updatedFields);
  };

  const handleDelete = (index) => {
    const updated = fieldData.filter((_, i) => i !== index);
    setFieldData(updated);
  };

  // INITIALIZE from currentPackage.itinerary only once
  useEffect(() => {
    if (
      !didInit.current &&
      currentPackage?.itinerary &&
      typeof currentPackage.itinerary === "string"
    ) {
      try {
        const parsed = JSON.parse(currentPackage.itinerary);
        const result = Object.entries(parsed).map(([_, value]) => ({
          title: value.title,
          description: value.content[0].description,
        }));
        setFieldData(result);
        didInit.current = true;
        prevItineraryRef.current = currentPackage.itinerary;
      } catch (e) {
        console.error("Error parsing itinerary JSON", e);
      }
    }
  }, [currentPackage?.itinerary]);

  // UPDATE parent state only when data changes
  useEffect(() => {
    const formattedItinerary = fieldData.reduce((acc, elem, index) => {
      acc[`day_${index + 1}`] = {
        title: elem.title,
        content: [{ description: elem.description }],
      };
      return acc;
    }, {});

    const newItineraryJSON = JSON.stringify(formattedItinerary);

    if (prevItineraryRef.current !== newItineraryJSON) {
      prevItineraryRef.current = newItineraryJSON;
      setState((prev) => ({
        ...prev,
        itinerary: newItineraryJSON,
      }));
    }
  }, [fieldData, setState]);

  return (
    <div style={{ padding: "12px" }}>
      <p style={{ fontWeight: "600" }}>Itinerary days</p>

      {fieldData.map((elem, indx) => (
        <div
          key={indx}
          style={{
            backgroundColor: "white",
            margin: "25px 0px",
            borderRadius: "12px",
            padding: "10px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>Day {indx + 1}</p>
            <img
              src={deleteIcon}
              alt="delete"
              style={{ height: "30px", width: "30px", cursor: "pointer" }}
              onClick={() => handleDelete(indx)}
            />
          </div>

          <p style={{ marginBottom: "2px" }}>Title</p>
          <input
            type="text"
            style={{
              width: "100%",
              height: "35px",
              backgroundColor: "#F4F4F4",
              borderRadius: "6px",
              padding: "9px",
              border: "none",
              marginBottom: "10px",
            }}
            value={elem.title}
            onChange={(e) => handleFieldChange(indx, "title", e.target.value)}
          />

          <p style={{ marginBottom: "2px" }}>Description</p>
          <CkEditor
            data={elem.description}
            handleChange={(newContent) =>
              handleFieldChange(indx, "description", newContent)
            }
          />
        </div>
      ))}

      <div
        onClick={handleAddField}
        style={{
          backgroundColor: "white",
          width: "110px",
          height: "38px",
          border: "1px solid black",
          padding: "8px",
          cursor: "pointer",
          fontSize: "15px",
          position: "relative",
        }}
      >
        Add Days
        <img
          src={PlusIcon}
          alt="add"
          style={{
            position: "absolute",
            left: "80%",
            top: "12px",
            height: "12px",
          }}
        />
      </div>
    </div>
  );
};

export default ItinraryBoxField;
